import Fields from '@components/fields'
import Column from '@components/column'
import ChooseSpecializations from '@commons/specializations'
import CardHeading from '@commons/headings/card'
import { Category } from '@apis'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Constant } from '@utils'
const InstitutionStep2Form = ({ setFieldValue, values, errors }) => {
  const { data: departments } = useSelector((state: any) => state.departments)
  const fetchDepartments = async () => {
    await Category.list({
      state: 'departments',
      params: {
        type: 'Department',
      },
    }).catch(() => {})
  }
  useEffect(() => {
    if (!departments?.length) {
      fetchDepartments()
    }
  }, [])

  return (
    <Column rowGap={15}>
      <Fields.DropDown
        name="departments"
        titleAsKey="name"
        valueAsKey="id"
        options={departments}
        placeholder="Select Your Department"
        label="Department"
        hasSearch
        isMultiple
      />
      <ChooseSpecializations
        isError={!!errors?.specializations}
        selectedItems={values?.specializations}
        onChange={(item: any) => {
          const findIndex = values?.specializations?.findIndex(
            (selected: any) => selected?.id == item.id,
          )
          if (findIndex >= 0) {
            setFieldValue(
              'specializations',
              values?.specializations?.filter(
                (symptom) => symptom?.id != item?.id,
              ),
            )
          } else {
            setFieldValue('specializations', [...values?.specializations, item])
          }
        }}
      />
      <Fields.DropDown
        options={Constant.instituteTypes}
        titleAsKey="label"
        valueAsKey="value"
        placeholder="Select Institute Type"
        label="Institute Type"
        name="instituteType"
      />
      <Fields.Map
        name="serviceArea"
        label="Delivery Range"
        placeholder="Delivery Range"
      />
      <Fields.Input
        type="number"
        name="yos"
        placeholder="Year of Service"
        label="Year of Service"
      />
      <Column bg="white">
        <CardHeading title="Services Provided By Institute:" />
        <Column styleColumn="margin-top:20px;">
          <Fields.GroupCheckBox
            name="serviceIncludes"
            options={Constant.services}
            titleAsKey="label"
            valueAsKey="value"
          />
        </Column>
      </Column>
    </Column>
  )
}

export default InstitutionStep2Form
